import { useQuery } from '@vue/apollo-composable';
import { computed } from '@nuxtjs/composition-api';

import { performanceCategoriesQuery } from '@/graphql/queries/performance-categories';
import type { PerformanceCategoriesQuery, PerformanceCategoriesQueryVariables, ScenkonstOtPerformanceCategoryContent } from '@/graphql/generated';

export type PerformanceCategory = ScenkonstOtPerformanceCategoryContent
export const usePerformanceCategories = () => {
  const { result, loading } = useQuery<PerformanceCategoriesQuery, PerformanceCategoriesQueryVariables>(performanceCategoriesQuery);

  return {
    performanceCategories: computed(() => result.value?.scenkonstOtPerformanceCategories || []),
    performanceCategoriesLoading: loading,
  };
};
